import { render, staticRenderFns } from "./liveTableList.vue?vue&type=template&id=64a280a6&scoped=true"
import script from "./liveTableList.vue?vue&type=script&lang=js"
export * from "./liveTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a280a6",
  null
  
)

export default component.exports